module.exports = __webpack_public_path__ + "img/splash.f5a46ef5.png";